import { useNavigate } from "react-router-dom";

import {
  UiBreadcrumb,
} from "libs/raas-ui-react-components/src/components";
import { LocalRoutes } from "local-routes";
import { IRouteObject } from "models/RouteInterface";
import { IBreadcrumProps } from "./Breadcrumb.model";
import useWindowSize from "hooks/useWindowSize";


export default function Breadcrumb(props: IBreadcrumProps) {
  const navigate = useNavigate();
  const { isXSView } = useWindowSize();
  const routeObject = LocalRoutes().find(
    (element: IRouteObject) => element?.path === props?.location?.pathname
  );

  return (
    <>
      {!isXSView &&
        <div className="m-0 row">
          <div className="p-0 offset-1 col-11"  id="breadcrumb">
            <UiBreadcrumb
              showBreadcrumb={!!routeObject?.breadcrumbList}
              literals={JSON.stringify(routeObject?.breadcrumbList || [])}
              onNavigateToEventClick={(e) => navigate(e?.detail)}
            ></UiBreadcrumb>
          </div>
        </div>
      }
    </>
  );
}
